import { withBrandLaunchLoginProps } from 'viewModel/brandLaunchLogin/withBrandLaunchLoginProps';
import BrandLaunchLogin from 'components/Brand/BrandLaunch/BrandLaunchLogin/BrandLaunchLogin';

export default withBrandLaunchLoginProps(BrandLaunchLogin);
